import React from 'react';
import { RupeeIcon } from '../../../../images/icons/icons';

const PipelineStageCard = ({ stage, isLast = false, background = "" }) => {
  return (
    <div className={`lms-closure-pipeline-tracker-stage-card ${background ? `lms-closure-pipeline-tracker-stage-card-${background}` : ""}`}>
      <div className="lms-closure-pipeline-tracker-stage-header">
        <h4 className="lms-closure-pipeline-tracker-stage-title">{stage.name} Leads</h4>
      </div>
      <div className="lms-closure-pipeline-tracker-stage-body">
        <div className="lms-closure-pipeline-tracker-stage-count">{stage.count}</div>
        <p className="lms-closure-pipeline-tracker-stage-value">Total Revenue : <RupeeIcon/>{stage.value}</p>
      </div>
      {!isLast && <div className="lms-closure-pipeline-tracker-stage-arrow"></div>}
    </div>
  );
};

export default PipelineStageCard; 